import { BRANDED_URL, AMPLIFY_APP_ID } from "@/api";

export const isAllowedBrandedOrigin = (origin) => {
  try {
    const defaultOrigin = new URL(BRANDED_URL).origin;
    if (origin === defaultOrigin) return true;

    const appId = AMPLIFY_APP_ID ||
      new URL(defaultOrigin).hostname.match(/^[^.]+\.([a-z0-9]+)\.amplifyapp\.com$/i)?.[1];

    if (appId) {
      const branchPattern = new RegExp(`^https://[a-z0-9-]+\\.${appId}\\.amplifyapp\\.com$`, "i");
      if (branchPattern.test(origin)) return true;
    }

    if (/^https?:\/\/localhost(?::\d+)?$/i.test(origin)) return true;

    return false;
  } catch {
    return false;
  }
};
